import { Component, OnInit, ViewChild } from '@angular/core';
import { Button } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { MultiSelectChangeEvent, MultiSelectModule } from 'primeng/multiselect';
import { Table, TableModule } from 'primeng/table';
import { TabViewModule } from "primeng/tabview";
import { DecimalPipe, NgForOf, NgIf, NgStyle } from "@angular/common";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { ECollection } from '../enums/ECollection';
import { IQueryFormat } from '../enums/types';
import { IInvoices, IInvoices_P, IInvoices_S } from '../interfaces/IInvoices';
import { IOrderHistoryData, IOrderHistoryData_P, IOrderHistoryData_S } from '../interfaces/IOrderHistoryData';
import { IUser_S } from '../interfaces/IUser';
import { AuthService } from "../service/auth.service";
import { InvoicesService } from '../service/invoices.service';
import { OrderCheckoutService } from '../service/order-checkout.service';
import { OrderFileUploadService } from '../service/order-file-upload.service';
import { UserService } from "../service/user.service";
import { ConstantsService } from "../service/constants.service";
import {
    EHeaderDBMaster,
    IDBMasterEventFromIframeToParent,
    IDBMasterEventFromParentToIframe
} from "../enums/EHeaderDBMaster";
import { EAllMasterNames } from "../enums/EAllMasterNames";
import { environment } from "../../environments/environment";
import { DialogModule } from "primeng/dialog";
import { InputTextModule } from "primeng/inputtext";
import { PasswordModule } from "primeng/password";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ToastModule } from "primeng/toast";
import html2pdf from 'html2pdf.js';
import { NotificationService } from "../service/notification.service";
import * as _ from "lodash";
import moment from "moment";

@Component({
    selector: 'app-myaccount',
    standalone: true,
    imports: [ TabViewModule, NgIf, ProgressSpinnerModule, DialogModule, InputTextModule, PasswordModule, ReactiveFormsModule, ToastModule, NgForOf, Button, TableModule, MultiSelectModule, FormsModule, MenuModule, NgStyle, DecimalPipe ],
    templateUrl: './myaccount.component.html',
    styleUrl: './myaccount.component.scss'
})
export class MyaccountComponent implements OnInit {
    loading: boolean = true;
    ledgerIFramePath!: SafeUrl;
    priceListIFramePath!: SafeUrl;
    ordersIFramePath!: SafeUrl;
    windowOnMessage: any;
    index: number = 0; // active tab index
    viewInvoice: boolean = false;
    viewImages: boolean = false;
    isDownloading = false;

    id = {
        idLedgerIFramePath: 'idLedgerIFramePath',
        idPriceListIFramePath: 'idPriceListIFramePath',
        idOrdersIFramePath: 'idOrdersIFramePath',
    };

    invoice: IInvoices = <any>{};
    imgSrc: string = '';

    AllMimeTypes: Record<string, string> = {
        '.jpg': 'image/jpeg',
        '.jpeg': 'image/jpeg',
        '.png': 'image/png'
    };

    selectedColumns: any = [];
    selectValue = [];
    dropDownArr: any = [];
    exportTypes: { label: EDBMasterGridExport, command: any }[] = [];
    @ViewChild('primeNGGrid') primeNGGrid: Table = <any>undefined;

    rows: IOrderHistoryData[] = [];
    fileUrlStart = environment.FILE_URL;

    columns = [
        {
            name: 'Bill No.',
            field: 'mpr_billNumber_str',
        },
        {
            name: 'Bill Date',
            field: 'mpr_billDate_dt',
        },
        {
            name: 'Job Name',
            field: 'jobName',
        },
        {
            name: 'Order Number',
            field: 'mpr_orderNumber_str',
        },
        {
            name: 'Net Amount',
            field: 'mpr_totalAmount',
        },
        {
            name: 'Order Status',
            field: 'mpr_order_status',
        },
        {
            name: 'Delivery Mode',
            field: 'mpr_deliveryMode_str',
        },
        {
            name: 'Docket No.',
            field: 'mpr_docketNumber_str',
        },
        {
            name: 'Dispatch Date',
            field: 'mpr_dispatchDate_dt',
        },
    ];

    globalSearchFieldVal = this.columns.map(e => {
        return e.field;
    });

    constructor(public authService: AuthService,
                private userService: UserService,
                private ns: NotificationService,
                public cs: ConstantsService,
                public orderFileUploadService: OrderFileUploadService,
                public orderCheckoutService: OrderCheckoutService,
                public invoicesService: InvoicesService,
                protected _sanitizer: DomSanitizer) {
    }

    ngOnInit() {

        this.exportTypes = this.getListOfAllExports();
        this.dropDownArr = this.columns;
        this.selectedColumns = this.dropDownArr;

        window.onmessage = this.windowOnMessage = async (e: any) => {
            const data = e.data;
            if (data.eventType === IDBMasterEventFromIframeToParent.PAGE_READY) {
                if (data.fromDBMaster === EAllMasterNames.LEDGER_USER) this.ledgerMasterLoaded();
                if (data.fromDBMaster === EAllMasterNames.PRICE_LIST) this.priceListMasterLoaded();
                if (data.fromDBMaster === EAllMasterNames.ORDER_HISTORY_USER) this.ordersMasterLoaded();
            }
            if (data.eventType === IDBMasterEventFromIframeToParent.CUSTOM_ACTION_BUTTON_CLICKED
                && data.fromDBMaster === EAllMasterNames.ORDER_HISTORY_USER
            ) {
                if (data.eventData.customActionButton.actionName === "view_invoice") {
                    if (data.eventData.rowData.mpr_order_status === "Dispatched") this.openInvoice(data.eventData.rowData).then();
                    else this.ns.showError('Invoice not available because item is not Dispatched.');
                }

                if (data.eventData.customActionButton.actionName === "view_images") {
                    if (data.eventData.rowData.mpr_cdrFiles_arr && data.eventData.rowData.mpr_cdrFiles_arr[0]) this.downloadAndPreviewDoc(data.eventData.rowData.mpr_cdrFiles_arr[0]);
                    else this.ns.showError("Image Does not Exist.");

                }
            }
        };

        this.ledgerIFramePath = this._sanitizer.bypassSecurityTrustResourceUrl(
            this.getFrameURL(EAllMasterNames.LEDGER_USER),
        );
        this.priceListIFramePath = this._sanitizer.bypassSecurityTrustResourceUrl(
            this.getFrameURL(EAllMasterNames.PRICE_LIST),
        );
        this.ordersIFramePath = this._sanitizer.bypassSecurityTrustResourceUrl(
            this.getFrameURL(EAllMasterNames.ORDER_HISTORY_USER),
        );

        setTimeout(() => {
            this.tabSelected({ index: this.index });
            this.loading = false;
        }, 100);
    }

    getFrameURL(masterName: string): string {
        let baseUrl = `${ environment.MADHURAM_BE_HOST_PORT }/dist-db-masters/browser/?`;
        const queryParams = [
            `${ EHeaderDBMaster.ADMIN_PATH }=${ environment.USER_PATH }`,
            `${ EHeaderDBMaster.DB_MASTER_NAME }=${ masterName }`,
            `${ EHeaderDBMaster.AUTHORIZATION_AM }=${ (this.userService.getAMUserFromLocalStorage(environment.crypto.passJWT)).amToken }`,
            `${ EHeaderDBMaster.AUTHORIZATION_AM_USER }=${ this.authService.token.accessToken }`,
            `${ EHeaderDBMaster.WAIT_FOR_PARENT_READY }=true`,
            `x-am-internationalization=EN`,
            // `${EHeaderDBMaster.SHOW_LOGS}=true`,
        ].join('&');
        return baseUrl + queryParams;
    }

    ledgerMasterLoaded() {
        const myIframe: any = document.getElementById(this.id.idLedgerIFramePath);
        if (myIframe?.contentWindow) {
            myIframe.contentWindow.postMessage({
                eventType: IDBMasterEventFromParentToIframe.SET_GLOBAL_DATA_TO_USE_IN_ANY_SCRIPT,
                eventData: {
                    // mpl_customer_objid: this.authService.gUser._id,
                }
            }, '*');
            myIframe.contentWindow.postMessage({
                eventType: IDBMasterEventFromParentToIframe.DATA_TO_APPEND_IN_GRID_LOAD_FIND_QUERY,
                eventData: {
                    mpl_customer_objid: this.authService.gUser._id,
                }
            }, '*');
            myIframe.contentWindow.postMessage({ eventType: IDBMasterEventFromParentToIframe.PARENT_READY }, '*');
        }
    }

    priceListMasterLoaded() {
        const myIframe: any = document.getElementById(this.id.idPriceListIFramePath);
        if (myIframe?.contentWindow) {
            myIframe.contentWindow.postMessage({
                eventType: IDBMasterEventFromParentToIframe.SET_GLOBAL_DATA_TO_USE_IN_ANY_SCRIPT,
                eventData: {
                    mpp_IsGstProduct_bl: !_.isEmpty(this.authService.gUser.usr_gstNumber_str)
                }
            }, '*');
            myIframe.contentWindow.postMessage({
                eventType: IDBMasterEventFromParentToIframe.DATA_TO_APPEND_IN_GRID_LOAD_FIND_QUERY,
                eventData: {
                    mpp_IsGstProduct_bl: !_.isEmpty(this.authService.gUser.usr_gstNumber_str)
                }
            }, '*');
            myIframe.contentWindow.postMessage({ eventType: IDBMasterEventFromParentToIframe.PARENT_READY }, '*');
        }
    }

    ordersMasterLoaded() {
        const myIframe: any = document.getElementById(this.id.idOrdersIFramePath);
        if (myIframe?.contentWindow) {
            myIframe.contentWindow.postMessage({
                eventType: IDBMasterEventFromParentToIframe.SET_GLOBAL_DATA_TO_USE_IN_ANY_SCRIPT,
                eventData: {
                    // userId: this.authService.getUserId()
                }
            }, '*');
            myIframe.contentWindow.postMessage({
                eventType: IDBMasterEventFromParentToIframe.DATA_TO_APPEND_IN_GRID_LOAD_FIND_QUERY,
                eventData: {
                    mpr_companyName_objid: this.authService.gUser._id,
                }
            }, '*');
            myIframe.contentWindow.postMessage({ eventType: IDBMasterEventFromParentToIframe.PARENT_READY }, '*');
        }
    }

    tabSelected(event: any) {
        this.index = event.index;

        if (this.index === 0) {
            setTimeout(() => this.getOrderHistoryData(), 50);
        }
        if (this.index === 1) {
            setTimeout(() => this.ledgerMasterLoaded(), 50);
        }
        if (this.index === 2) {
            setTimeout(() => this.priceListMasterLoaded(), 50);
        }
    }

    async openInvoice(rowData: any) {
        if (rowData.mpr_order_status !== "Dispatched") {
            this.ns.showError("Invoice Not Available");
            return;
        }
        let query: IQueryFormat = {
            find: <IInvoices_P>{
                mpi_user_objid: this.authService.getUserId(),
                active: true,
                mpi_order_objid: rowData._id,
            },
            select: <IInvoices_S>{
                createdAt: 1,
                mip_description_arr: 1,
                mpi_gst_num: 1,
                mpi_delivery_address_str: 1,
                mpi_invoice_date_str: 1,
                mpi_invoice_number_str: 1,
                mpi_order_objid: 1,
                mpi_sub_total_num: 1,
                mpi_is_gst_bl: 1,
                mpi_total_amount_num: 1,
                mpi_transport_charges_num: 1,
                mpi_user_objid: 1,
                mpi_total_amount_in_word_str: 1,
                mpi_special_remark_str: 1,
                mpi_extra_num: 1,
                mpi_discount_num: 1,
            },
            deep: [
                {
                    s_key: "mpi_user_objid",
                    t_instance: environment.INS,
                    t_db: environment.DB,
                    t_col: ECollection.MP_USERS,
                    t_key: "_id",
                    select: <IUser_S>{
                        usr_customerName_str: 1,
                        usr_companyName_str: 1,
                        usr_address_str: 1,
                        usr_state_str: 1,
                        usr_email_str: 1,
                        usr_mobile_number_num: 1,
                        usr_userName_str: 1,
                        usr_cityName_str: 1,
                        usr_pincode_num: 1,
                        usr_district_str: 1,
                        usr_gstNumber_str: 1,
                    },
                    // deep: [
                    //     {
                    //         s_key: "cities_objid",
                    //         t_instance: environment.INS,
                    //         t_db: environment.DB,
                    //         t_col: ECollection.MP_CITIES,
                    //         t_key: "_id",
                    //         select: { mpc_cityName_str: 1 }
                    //     }
                    // ]
                },
                {
                    s_key: "mpi_order_objid",
                    t_instance: environment.INS,
                    t_db: environment.DB,
                    t_col: ECollection.MP_ORDERS,
                    t_key: "_id",
                    select: <IOrderHistoryData_S>{ mpr_orderNumber_str: 1, mpr_itemDetails_arr: 1 }
                }
            ],
            sort: <IInvoices_S>{ createdAt: -1 }
        };
        let res = await this.invoicesService.query(query);
        if (res && res.length) {
            this.invoice = res[0];
            let items = res[0].mpi_order_objid.mpr_itemDetails_arr[0]
            this.invoice.halfBladeCost = items.halfBladeCost;
            this.invoice.punchingCost = items.punchingCost;
            this.invoice.crizzingCost = items.crizzingCost;
            this.invoice.dieCost = items.dieCost;
            this.invoice.perforateCost = items.perforateCost;
            this.invoice.foldingCost = items.foldingCost;

            const baseSubtotal = Number(this.invoice.mpi_sub_total_num) || 0;
            const totalCharges = (Number(this.invoice.halfBladeCost) || 0) + (Number(this.invoice.punchingCost) || 0) + (Number(this.invoice.perforateCost) || 0) +
                (Number(this.invoice.crizzingCost) || 0) + (Number(this.invoice.dieCost) || 0) + (Number(this.invoice.foldingCost) || 0);

            this.invoice.mpi_sub_total_num = Number(
                (baseSubtotal - totalCharges).toFixed(2)
            );
        }
        this.viewInvoice = true;
    }

    async downloadPDF() {
        const element: any = document.querySelector('.invoice-dialog');
        if (!element) {
            console.error('Invoice element not found');
            return;
        }
        this.isDownloading = true;
        const opt: any = {
            margin: [ 5, 5, 5, 5 ], // mm
            filename: 'invoice.pdf',
            image: { type: 'jpeg', quality: 1 }, // best quality
            html2canvas: { scale: 2, useCORS: true }, // sharper text/images
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
        };
        try {
            await html2pdf().set(opt).from(element).save();
        } catch (err) {
            console.error('PDF generation error:', err);
        }
        this.isDownloading = false;
    }

    openPrintDialog() {
        let printContents = document.getElementById('invoice-print-area')?.innerHTML;
        const baseUrl = location.origin;
        printContents = printContents?.replace(/\.\/assets\//g, `${ baseUrl }/assets/`);
        const printWindow = window.open('');
        printWindow!.document.write(`
        <html lang="">
          <head>
            <style>
                @media print {
                    .print-mb-bt {margin-bottom: 2mm !important;}
                    .print-mt-tp {margin-top: 2mm !important;}
                    .print-mb-bt-1 {margin-bottom: 5px !important;}
                }
                @page { size: A4; margin: 0; }
                body { padding: 5mm; margin: 0; font-family: Arial, sans-serif; color: #333333;display: flex;flex-direction: column;align-items: center;justify-content: space-between;gap: 10px; }
                table { width: 100%; border-collapse: collapse; page-break-inside: auto; }
                th, td { border: 1px solid #ccc; padding: 4px; font-size: 12px;}
                th { background-color: #f2f2f2;}
                img {max-width: 100%;}

            </style>
            <title>Print</title>
          </head>
          <body>
            ${ printContents }
          </body>
        </html>
      `);
        setTimeout(() => {
            printWindow!.focus();
            printWindow!.print();
            printWindow!.close();
        }, 500);
    }

    getPagedItems(items: any[] = [], pageSize: number = 8): any[][] {
        const pages: any[][] = [];

        // Split items into pages
        for (let i = 0; i < items.length; i += pageSize) {
            const page = items.slice(i, i + pageSize);

            // If last page has less than pageSize rows → fill with empty placeholders
            while (page.length < pageSize) {
                page.push({
                    productGroup: '',
                    productName: '',
                    hsnCode: '',
                    quantity: '',
                    rate: '',
                    amount: ''
                });
            }
            pages.push(page);
        }
        return pages;
    }

    async downloadAndPreviewDoc(dataItem: { originalName: '', uploadPath: '' }) {
        try {
            this.imgSrc = '';
            this.loading = true;
            const resp = await this.orderFileUploadService.fileDownload(dataItem);
            this.loading = false;
            const mimeType = this.getMimeTypeFromName(dataItem.originalName);
            this.imgSrc = `data:${ mimeType };base64,${ resp }`;
            this.viewImages = true;
        } catch (e) {
            this.loading = false;
            this.ns.showErrorFromResponse((<any>e)?.error || e, 'File download operation failed.');
        }
    }

    showPreview(fileName: string, base64Content: any) {
        const mimeType = this.getMimeTypeFromName(fileName);
        return `data:${ mimeType };base64,${ base64Content }`;
        // this.selectedData = `data:${mimeType};base64,${base64Content}`;
    }

    getMimeTypeFromName(name: string): string {
        const fileNameL = (name || '').toLowerCase();

        let extension = fileNameL.split('.').pop();
        let mimeType: string = 'text/plain';
        if (extension) {
            extension = '.' + extension;

            // @ts-ignore
            mimeType = this.AllMimeTypes[extension];
        }

        if (mimeType) return mimeType;
        else return 'text/plain';
    }

    setSelectedColumns(e: any) {
        setTimeout(() => {
            this.columns = [ ...this.selectedColumns ];
        }, 100);
    }

    // onRowExpand(event: TableRowExpandEvent) {
    //     this.expandedRows = { [event.data.quizTitle]: true };
    // }

    getListOfAllExports() {
        const exportTypes = [];
        exportTypes.push({ label: EDBMasterGridExport.EXPORT_ALL, command: this.onExportTypeChange.bind(this) });
        exportTypes.push({
            label: EDBMasterGridExport.EXPORT_SELECTED,
            command: this.onExportTypeChange.bind(this),
        });
        return exportTypes;
    }

    onExportTypeChange($event: any) {
        const item: { label: EDBMasterGridExport } = $event.item;
        if (item.label === EDBMasterGridExport.EXPORT_ALL) {
            this.primeNGGrid.exportCSV();
        } else if (item.label === EDBMasterGridExport.EXPORT_SELECTED) {
            this.primeNGGrid.exportCSV({ selectionOnly: true });
        }
    }

    columnSelectionOnChange(event: MultiSelectChangeEvent) {
        this.selectedColumns = _.sortBy(this.selectedColumns, 'columnOrder');
        if (this.selectedColumns.length === 0) {
            this.selectedColumns = [ this.columns[0] ];
        }
    }

    async getOrderHistoryData() {
        this.loading = true;
        this.rows = [];
        let query: IQueryFormat = {
            find: <IOrderHistoryData_P>{
                mpr_user_objid: this.authService.getUserId()
            },
            select: <IOrderHistoryData_S>{
                _id: 1,
                mpr_dispatchDate_dt: 1,
                mpr_cdrFiles_arr: 1,
                mpr_billDate_dt: 1,
                mpr_order_status: 1,
                mpr_billNumber_str: 1,
                mpr_totalAmount: 1,
                mpr_orderNumber_str: 1,
                mpr_deliveryMode_str: 1,
                mpr_docketNumber_str: 1,
                mpr_companyName_objid: 1,
                mpr_itemDetails_arr: 1,
            },
            sort: <IOrderHistoryData_S>{ createdAt: -1 }
        };
        let rawData: IOrderHistoryData[] = await this.orderCheckoutService.query(query);

        for (let item of rawData) {
            if (item.mpr_itemDetails_arr && item.mpr_itemDetails_arr.length) item.jobName = item.mpr_itemDetails_arr[0].jobName;
            else item.jobName = '';
            item.fullFileUrl = item.mpr_cdrFiles_arr?.[0] ? this.fileUrlStart + item.mpr_cdrFiles_arr[0].uploadPath : undefined;
            if (item.mpr_dispatchDate_dt) {
                let dispatchDate = item.mpr_dispatchDate_dt;
                item.mpr_dispatchDate_dt = moment(dispatchDate).local().format('DD-MM-YYYY h:mm A');
            }
            if (item.mpr_billDate_dt) {
                let billDate = item.mpr_billDate_dt;
                item.mpr_billDate_dt = moment(billDate).local().format('DD-MM-YYYY h:mm A');
            }
        }
        this.rows = rawData;
        this.loading = false;
    }

    getOrderStatusStyle(status: string) {
        if (!status) return {};
        const baseStyle = {
            'font-weight': 700,
            color: 'white',
            padding: '5px 12px',
            'border-Radius': '40px',
            width: 'fit-content',
            'font-size': '13px'
        };

        switch (status) {
            case 'In Progress':
                return { ...baseStyle, 'background-color': '#dc3545' };
            case 'Dispatched':
                return { ...baseStyle, 'background-color': '#01a757' };
            case 'Accepted':
                return { ...baseStyle, 'background-color': '#e3aa00' };
            default:
                return baseStyle;
        }
    }

}

enum EDBMasterGridExport {
    EXPORT_ALL = 'Export All',
    EXPORT_SELECTED = 'Export Selected',
}
